exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nav-bottom {\n  transition: transform 0.3s ease-in-out;\n}\n.nav-bottom.hidden {\n  transform: translateY(100%);\n}\n", ""]);

// exports
